import { render, staticRenderFns } from "./twitter_post_embed.vue?vue&type=template&id=7def769e&scoped=true"
import script from "./twitter_post_embed.vue?vue&type=script&lang=ts"
export * from "./twitter_post_embed.vue?vue&type=script&lang=ts"
import style0 from "./twitter_post_embed.vue?vue&type=style&index=0&id=7def769e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def769e",
  null
  
)

export default component.exports